<template>
  <b-container>
    <loading v-show="isLoading" color="#00a088"></loading>
    <div class="wrapper box-shadow">
      <b-row class="align-items-center img-panel">
      </b-row>
      <b-row>
        <b-col>
          <twitter v-if="showTwitter" v-on:loaded="formLoaded" v-on:submit="formSubmit"></twitter>
          <youtube v-if="showYoutube" v-on:loaded="formLoaded" v-on:submit="formSubmit"></youtube>
          <pinterest v-if="showPinterest" v-on:loaded="formLoaded" v-on:submit="formSubmit"></pinterest>
          <google-plus v-if="showGooglePlus" v-on:loaded="formLoaded" v-on:submit="formSubmit"></google-plus>
          <slack v-if="showSlack" v-on:loaded="formLoaded" v-on:submit="formSubmit"></slack>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import Loading from '../components/Loading'
import Twitter from '../components/socials/Twitter'
import Youtube from '../components/socials/Youtube'
import Pinterest from '../components/socials/Pinterest'
import GooglePlus from '../components/socials/GooglePlus'
import Slack from '../components/socials/Slack'
import {postToClient, getSocialRedirectURL} from '../services/api.js'
export default {
  name: 'ShareContent',
  components: {
    Loading,
    Twitter,
    Youtube,
    Pinterest,
    GooglePlus,
    Slack
  },
  data() {
    return {
      isLoading: true,
      showTwitter: false,
      showYoutube: false,
      showPinterest: false,
      showGooglePlus: false,
      showSlack: false,
      socialType: '',
      fileType: '',
      clientURL: '',
      shareId: '',
      apiToken: '',
      userToken: '',
      ip: '',
      port: '',
    }
  },
  methods: {
    formLoaded() {
      this.isLoading = false
    },
    formSubmit(data) {
      //submit data to client
      if(this.clientURL && this.shareId) {
        //encode all data
        for(let key in data) {
          data[key] = encodeURIComponent(data[key])
        }

        let clientData = {};
        clientData['share_id'] = this.shareId
        clientData['social_token'] = this.userToken
        clientData['share_data'] = JSON.stringify(data)
        postToClient(this.clientURL, clientData)
          .then(response => {
            let status = response.status
            if (status == 200) {
              //success
              this.$router.push({path:'/status', query: {share_id: this.shareId, ip: this.ip, port: this.port}})
            } else if(status == 2) {
              //failed
              this.alertMessage("Received Status 2 from Client.")
            }
          })
          .catch(error => {
            this.alertMessage(error)
          })
      } else {
        this.alertMessage("Missing client url, please try again.")
      }
    },
    setAllFormFalse() {
      this.showTwitter = false;
      this.showYoutube = false;
      this.showPinterest = false;
      this.showGooglePlus = false;
    },
    changeViewBySocialType(route) {
      this.isLoading = true
      this.setAllFormFalse()


      let socialName = this.socialType[0].toUpperCase() + this.socialType.substring(1)
      let showFormPropety = "show" + socialName
      this[showFormPropety] = true

      route.meta.title = "share.content." + this.socialType + "_title"
      this.$emit('titleChange', route.meta.title)
    },
    validateQueryParams(route) {
      let validateResult = true

      // if(!this.apiToken) {
      //   this.alertMessage("Missing params token")
      //   validateResult = false
      // }

      this.ip = route.query.ip
      if(!this.ip) {
        this.alertMessage("Missing params ip.")
        validateResult = false
      }

      this.port = route.query.port
      if(!this.port) {
        this.alertMessage("Missing params port")
        validateResult = false
      }
      this.clientURL = "http://" + this.ip + ":" + this.port

      this.shareId = route.query.share_id
      if(!this.shareId) {
        this.alertMessage("Missing params share_id")
        validateResult = false
      }
      return validateResult
    },
    initPage(route) {
      this.socialType = route.params.socialType
      this.fileType = route.params.fileType
      this.apiToken = route.query.token

      let result = this.validateQueryParams(route)
      if(!result) {
        this.setAllFormFalse()
        this.isLoading = false
      } else {
        let cookieName = 's-token-' + this.socialType
        this.userToken = this.$cookie.get(cookieName)
        //Is the user logged in to social platform?
        if(this.userToken) {
          this.changeViewBySocialType(route)
        } else {
          let currentURL = window.location.href
          this.$cookie.set('redirectURL', currentURL, {expires: '5m'})          
          getSocialRedirectURL(this.socialType)
            .then(url => {
              window.location.replace(url)
            })
            .catch(error => {
              this.alertMessage(error)
            })
        }
      }
    },
    alertMessage(message) {
      this.$toasted.error(message)
    }
  },
  mounted() {
    this.initPage(this.$route)
  },
  beforeRouteUpdate(to, from ,next) {
    this.initPage(to)
    next()
  }
}
</script>

